import type {ReportStatus} from 'web-app/react/modals-container/manage-report-modal/types';

export type KIND = 'ACCIDENT' | 'INCIDENT';

export const DEFAULT_REPORT_STATUS: ReportStatus = 'PENDING_REVIEW';
